export type RangeKey = '24h' | '7d' | '30d' | '90d'

export const RANGE_OPTIONS: { value: RangeKey; label: string; hours: number }[] = [
    { value: '24h', label: '24 hours', hours: 24 },
    { value: '7d', label: '7 days', hours: 24 * 7 },
    { value: '30d', label: '30 days', hours: 24 * 30 },
    { value: '90d', label: '90 days', hours: 24 * 90 },
]

export const rangeBounds = (key: RangeKey) => {
    const option = RANGE_OPTIONS.find((o) => o.value === key) || RANGE_OPTIONS[1]
    const to = new Date()
    const from = new Date(to.getTime() - option.hours * 3600000)
    return { from: from.toISOString(), to: to.toISOString() }
}

export interface OrgActivity {
    organisation: string
    users: number
    visits: number
    calls: number
    actions: number
    errors: number
    lastSeen: string | null
}

export interface UserActivitySummary {
    cognitoId: string
    email: string
    name: string | null
    organisation: string | null
    visits: number
    calls: number
    actions: number
    errors: number
    lastSeen: string | null
    lastPage: string | null
    lastIp: string | null
}

export interface VisitSummary {
    searches: { value: string; results: number | null }[]
    opened: string | null
    actions: number
    errors: number
    calls: number
    label: string
}

export interface Visit {
    at: string
    until: string
    ip: string | null
    page: string | null
    path: string | null
    implicit: boolean
    summary: VisitSummary
}

export interface TimelineUser {
    cognitoId: string
    email: string | null
    name: string | null
    organisation: string | null
    lastIp: string | null
    lastSeen: string | null
}

export interface VisitCall {
    id: number
    at: string
    path: string
    method: string | null
    status: number | null
    durationMs: number | null
    params: Record<string, unknown> | null
    resultCount: number | null
    ip: string | null
}
